import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import API from "./plugins/axios";

Vue.prototype.$api = API;
Vue.prototype.$window = window;
Vue.config.productionTip = false;

store.$api = API;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
